import React from 'react'
import {
  CREATE_WEB_USER,
  GET_APP_SETTING_BY_NAME,
  SEND_EMAIL_REGISTRATION,
  SEND_EMAIL_VERIFICATION,
} from '../../../requests'
import { MASK, VALIDATE } from 'components/Wizard2/validate'
import { Spinner } from '../../Loaders/Loaders'

const minimumNumPassword = process.env.MINIMUM_PASSWORD_LENGTH || 10

export default class CreateAccountForm extends React.Component {
  state = {
    errors: {},
    emailVerification: false,
    emailVerificationSent: false,
    emailVerificationSentTwice: false,
    emailVerificationLoading: false,
    email: '',
  }

  componentDidMount() {
    this.setState({ emailVerificationLoading: true })

    GET_APP_SETTING_BY_NAME(
      'UserRegistrationWithEmailVerification',
      (data) => {
        this.setState({
          emailVerification: data.VALUE.toLowerCase() === 'true',
          emailVerificationLoading: false,
        })
      },
      (err) => {
        console.error(err)
        this.setState({
          errors: {
            global: err.message || 'Something went wrong, try again later',
          },
          emailVerificationLoading: false,
        })
      }
    )
  }

  checkEnter = (e) => {
    if (e.charCode === 13) {
      this.validate()
    }
  }
  validateAccountCreation = async () => {
    const account = {
      firstName: this.firstName.value,
      lastName: this.lastName.value,
      orgName: process.env.SHOW_ORG_NAME_ACCOUNT_CREATE ? this.orgName.value : '',
      email: this.email.value,
      phone: this.phone.value,
      password: this.password.value,
      confirmPassword: this.confirmPassword.value,
    }
    let errors = {}
    if (!account.firstName) {
      errors.firstName = 'First name is required'
    }
    if (!account.lastName) {
      errors.lastName = 'Last name is required'
    }
    const emailRegEx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    if (!account.email) {
      errors.email = 'An email is required'
    }

    if (!emailRegEx.test(account.email)) {
      errors.email = 'Must be a properly formatted email'
    }
    if (
      !account.phone ||
      !(await new Promise((resolve) =>
        VALIDATE.validPhoneNumber(account.phone, {}, {}, (isValid) => resolve(isValid))
      ))
    ) {
      errors.phone = 'A phone number is required'
    }
    if (!account.password) {
      errors.password = 'A password is required'
    }
    // else if (account.password.length < minimumNumPassword) { // handled by endpoint
    //   errors.password = `Password must be at least ${minimumNumPassword} characters`
    // }
    if (account.password !== account.confirmPassword) {
      errors.confirmPassword = 'Passwords must match'
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ errors: errors })
    } else {
      this.setState({ errors: {} })
      this.createAccount(account)
    }
  }

  validateEmailVerification = async () => {
    const account = {
      firstName: this.firstName.value,
      lastName: this.lastName.value,
      orgName: process.env.SHOW_ORG_NAME_ACCOUNT_CREATE ? this.orgName.value : '',
      email: this.email.value,
      phone: this.phone.value,
    }
    let errors = {}
    if (!account.firstName) {
      errors.firstName = 'First name is required'
    }
    if (!account.lastName) {
      errors.lastName = 'Last name is required'
    }
    const emailRegEx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    if (!account.email) {
      errors.email = 'An email is required'
    }

    if (!emailRegEx.test(account.email)) {
      errors.email = 'Must be a properly formatted email'
    }
    if (
      !account.phone ||
      !(await new Promise((resolve) =>
        VALIDATE.validPhoneNumber(account.phone, {}, {}, (isValid) => resolve(isValid))
      ))
    ) {
      errors.phone = 'A phone number is required'
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ ...this.state, errors: errors })
    } else {
      this.setState({ ...this.state, errors: {} })
      this.sendEmailRegistration(account)
    }
  }

  createAccount = (account) => {
    CREATE_WEB_USER(
      account,
      (userId) => {
        this.props.returnToLogin({
          type: 'success',
          message: 'Your account was successfully created. Please login below.',
        })
      },
      (err) => {
        console.error(err)
        this.setState({
          errors: {
            global: err.message || 'Something went wrong, try again later',
          },
        })
      }
    )
  }

  sendEmailRegistration = (account) => {
    SEND_EMAIL_REGISTRATION(
      account,
      (userId) => {
        this.setState({ ...this.state, emailVerificationSent: true })
        this.setState({ ...this.state, email: account.email })
      },
      (err) => {
        this.setState({
          errors: {
            global: err.message || 'Something went wrong, try again later',
          },
        })
      }
    )
  }

  sendEmailVerification = () => {
      this.setState({ ...this.state, emailVerificationSentTwice: true })
      SEND_EMAIL_VERIFICATION({userId: this.state.email}, () => {
        this.props.returnAndDisplaySuccess()
      },
      (err) => {
        this.setState({
          errors: {
            global: err.message || 'Something went wrong, try again later',
          },
        })
      }
    )
  }

  render() {
    if (this.state.emailVerificationLoading) {
      return (
        <div className="flex-center">
          <Spinner size={'small'} themeColor={'dark-neutral'}></Spinner>
        </div>
      )
    }

    const { returnToLogin } = this.props

    return (
      <div>
        {this.state.emailVerificationSent ? (  
          <div>                 
            <p className="description">
              An email has been sent to your email address. Please follow the instructions in the
              email to finish creating your account.            
            </p>
            {!this.state.emailVerificationSentTwice ?             
            (
              <div className="button-wrapper create-wrapper">
                <button type="button" className="create-account-button" onClick={this.sendEmailVerification}>
                Resend Email
                </button>
              </div>
            ) : null}
          </div>
        ) : (
          <form className="login create-account">
            <div className="name-wrapper">
              <div className="field">
                <label htmlFor="firstName" id="firstName-label">
                  First name
                </label>
                <input
                  type="text"
                  ref={(ref) => {
                    this.firstName = ref
                  }}
                  onKeyDown={this.checkEnter}
                  placeholder="John"
                  id="firstName"
                  aria-describedby="firstName-error"
                  aria-invalid={!!this.state.errors.firstName}
                  aria-labelledby="firstName-label"
                />
                <FieldError id="firstName-error">{this.state.errors.firstName}</FieldError>
              </div>
              <div className="field">
                <label htmlFor="lastName" id="lastName-label">
                  Last name
                </label>
                <input
                  type="text"
                  ref={(ref) => {
                    this.lastName = ref
                  }}
                  onKeyDown={this.checkEnter}
                  placeholder="Doe"
                  id="lastName"
                  aria-describedby="lastName-error"
                  aria-invalid={!!this.state.errors.lastName}
                  aria-labelledby="lastName-label"
                />
                <FieldError id="lastName-error">{this.state.errors.lastName}</FieldError>
              </div>
            </div>
            {process.env.SHOW_ORG_NAME_ACCOUNT_CREATE ? (
              <div className="field">
                <label htmlFor="orgName" id="orgName-label">
                  Organization name
                </label>
                <input
                  type="text"
                  ref={(ref) => {
                    this.orgName = ref
                  }}
                  onKeyDown={this.checkEnter}
                  placeholder="Your LLC"
                  id="orgName"
                  aria-labelledby="orgName-label"
                />
              </div>
            ) : null}
            <div className="field">
              <label htmlFor="email" id="email-label">
                Email
              </label>
              <input
                type="text"
                ref={(ref) => {
                  this.email = ref
                }}
                onKeyDown={this.checkEnter}
                placeholder="example@email.com"
                maxLength={100}
                id="email"
                aria-describedby="email-error"
                aria-invalid={!!this.state.errors.email}
                aria-labelledby="email-label"
              />
              <FieldError id="email-error">{this.state.errors.email}</FieldError>
            </div>
            <div className="field">
              <label htmlFor="phone" id="phone-label">
                Phone
              </label>
              <input
                type="text"
                autoComplete="tel"
                onChange={(e) => (this.phone.value = MASK.phone(e.target.value))}
                ref={(ref) => {
                  this.phone = ref
                }}
                onKeyDown={this.checkEnter}
                placeholder="###-###-####"
                id="phone"
                aria-describedby="phone-error"
                aria-invalid={!!this.state.errors.phone}
                aria-labelledby="phone-label"
              />
              <FieldError id="phone-error">{this.state.errors.phone}</FieldError>
            </div>

            {!this.state.emailVerification ? (
              <div>
                <div className="field">
                  <label htmlFor="password-field" id="password-label">
                    Password
                  </label>
                  <span className="description" id="password-description">
                    {process.env.PASSWORD_REQUIREMENTS_ACCOUNT_CREATE ? (
                      <span
                        dangerouslySetInnerHTML={{
                          __html: process.env.PASSWORD_REQUIREMENTS_ACCOUNT_CREATE,
                        }}
                      ></span>
                    ) : (
                      `Must be at least ${minimumNumPassword} characters`
                    )}
                  </span>
                  <input
                    type="password"
                    ref={(ref) => {
                      this.password = ref
                    }}
                    onKeyDown={this.checkEnter}
                    placeholder=""
                    id="password-field"
                    aria-describedby="password-description . password-error"
                    aria-invalid={!!this.state.errors.password}
                    aria-labelledby="password-label"
                  />
                  <FieldError id="password-error">{this.state.errors.password}</FieldError>
                </div>
                <div className="field">
                  <label htmlFor="confirm-password" id="confirm-label">
                    Confirm Password
                  </label>
                  <input
                    type="password"
                    ref={(ref) => {
                      this.confirmPassword = ref
                    }}
                    onKeyDown={this.checkEnter}
                    placeholder=""
                    id="confirm-password"
                    aria-describedby="confirm-error"
                    aria-invalid={!!this.state.errors.confirmPassword}
                    aria-labelledby="confirm-label"
                  />
                  <FieldError id="confirm-error">{this.state.errors.confirmPassword}</FieldError>
                </div>
              </div>
            ) : null}

            <div className="button-wrapper create-wrapper">
              <button
                type="button"
                className="btn-raised btn-light-primary submit"
                onClick={
                  this.state.emailVerification
                    ? this.validateEmailVerification
                    : this.validateAccountCreation
                }
              >
                {this.state.emailVerification ? 'SUBMIT' : 'CREATE ACCOUNT'}
              </button>
              <FieldError role="alert">{this.state.errors.global}</FieldError>
            </div>

            <div className="button-wrapper create-wrapper">
              <button type="button" className="create-account-button" onClick={returnToLogin}>
                Login with existing account
              </button>
            </div>
          </form>
        )}
      </div>
    )
  }
}

export const FieldError = ({ children, id = '', role }) =>
  children ? (
    <p className="field-error animated fadeIn fast-animation" id={id} role={role}>
      {children}
    </p>
  ) : null
